import React, { useEffect, Children } from 'react';
import { Link } from 'react-router-dom';
export function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white min-h-screen" data-id="element-168" data-mp="9ywdcvpbj2q8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 space-y-20" data-id="element-169" data-mp="550med7h2g4k">
        {/* Intro Section */}
        <section data-id="element-170" data-mp="5xln4yiyw2e">
          <h1 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-6" data-id="element-171" data-mp="6gyi79biu9k">
            About The Good Father Project
          </h1>
          <p className="text-xl text-[#5a3a28] leading-relaxed" data-id="element-172" data-mp="3me6zc3z2tbcg">
            The Good Father Project is a community initiative that honors
            fathers and father-figures through the words of their children. It
            began as a simple idea that recognizing the quiet, steady work of
            fatherhood could strengthen families and communities.
          </p>
        </section>

        {/* What the Project Is */}
        <section data-id="element-173" data-mp="1bmxgo8c9bp04">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3b2316] mb-4" data-id="element-174" data-mp="1bmf9whryxsdy">
            What the Project Is
          </h2>
          <p className="text-lg text-[#5a3a28]/90 leading-relaxed mb-8" data-id="element-175" data-mp="2eyk94secx1vh">
            At its heart, The Good Father Project invites children to write
            essays about the fathers and father-figures who matter most to them.
            These essays are shared, celebrated, and honored at community events
            as an act of gratitude and connection.
          </p>
          <div className="flex flex-col items-center gap-3" data-id="element-176" data-mp="2ykq8ybr9z2n3">
            <div className="relative" data-id="element-177" data-mp="32m1rjxbqenls">
              <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-178" data-mp="32l0g3rqszz3j"></div>
              <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-179" data-mp="2ou562c4kjbyd">
                <img src="https://cdn.magicpatterns.com/uploads/6Ym5vZu4XnCm6QbFtUYqye/493815572_9374528642659468_7603856205039483468_n.jpg" alt="Children on bicycles reading essays posted on a community wall" className="w-full h-full object-cover" data-id="element-180" data-mp="3hj2lm7heaunf" />
              </div>
            </div>
            <p className="text-sm text-[#5a3a28]/70 italic text-center mt-2" data-id="element-181" data-mp="3r77wg15o5hxr">
              Children reading essays honoring fathers and father-figures at a
              community display.
            </p>
          </div>
        </section>

        {/* Our Story / Where It Began */}
        <section data-id="element-182" data-mp="3d7yqrvf3a681">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3b2316] mb-4" data-id="element-183" data-mp="3d8gjii2jm2b7">
            Where It Began
          </h2>
          <div className="space-y-6 text-lg text-[#5a3a28]/90 leading-relaxed" data-id="element-184" data-mp="38e418bcsyx11">
            <p data-id="element-185" data-mp="33hlvb85qksn4">
              The Good Father Project was first launched in Mongolia during{' '}
              <a href="https://travishellstrom.com/goodfatherproject" target="_blank" rel="noopener noreferrer" className="text-[#c06a2b] hover:underline font-medium" data-id="element-186" data-mp="2yjkgizfcffhg">
                Peace Corps service
              </a>
              . Known locally as Сайн Аав Төсөл (Sain Aav Tosol), it grew from
              conversations with families, teachers, and community members about
              the role of fathers in children's lives.
            </p>
            <div className="flex flex-col items-center gap-3" data-id="element-187" data-mp="1dy5i9eeuh9ab">
              <div className="relative" data-id="element-188" data-mp="1iyjjaci13iyu">
                <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-189" data-mp="lbb5l3o9re7e"></div>
                <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-190" data-mp="qa4iouzn9371">
                  <img src="https://cdn.magicpatterns.com/uploads/oXBvEyUu6hJFD7SUtWtY5J/4534377.jpg" alt="A grandfather holding his young grandson, both smiling, in Mongolia" className="w-full h-full object-cover" data-id="element-191" data-mp="v8fs54m11boq" />
                </div>
              </div>
              <p className="text-sm text-[#5a3a28]/70 italic text-center mt-2" data-id="element-192" data-mp="7i1zpczj5atm">
                A grandfather and his grandson in Mongolia, where The Good
                Father Project first began.
              </p>
            </div>
            <p data-id="element-193" data-mp="2iylmzq7kwacz">
              On International Children's Day, fathers and father-figures were
              honored in a public celebration - a moment of recognition that
              resonated deeply across the community. The project emerged through
              relationships, listening, and shared values: a belief that
              honoring fathers could be a quiet but powerful act of community
              building.
            </p>
          </div>
        </section>

        {/* Video Section */}
        <section className="my-12" data-id="element-194" data-mp="2wywhd383k72w">
          <div className="rounded-xl overflow-hidden shadow-lg border border-[#ecdfd2] bg-[#ecdfd2]/20" data-id="element-195" data-mp="2wzy1ryb065xa">
            <div className="aspect-video w-full" data-id="element-196" data-mp="17k8djqdknxgh">
              <iframe className="w-full h-full" src="https://www.youtube.com/embed/POBzwObdprI" title="The Good Father Project - Peace Corps Mongolia" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-197" data-mp="12kvhqg4q3g1r"></iframe>
            </div>
            <div className="p-4 text-center" data-id="element-198" data-mp="39g77vbugxv0s">
              <p className="text-sm text-[#5a3a28]/70 italic" data-id="element-199" data-mp="39ew2x8paeh83">
                This video reflects the early roots and inspiration of The Good
                Father Project during Peace Corps service in Mongolia.
              </p>
            </div>
          </div>
        </section>

        {/* Bringing It Home */}
        <section data-id="element-200" data-mp="2qiebyti9ilcw">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3b2316] mb-4" data-id="element-201" data-mp="2qhuz3r7gyn5q">
            Bringing It Home
          </h2>
          <p className="text-lg text-[#5a3a28]/90 leading-relaxed mb-8" data-id="element-202" data-mp="kqr83bqx6nbh">
            The values at the center of The Good Father Project - gratitude,
            presence, and community - are not unique to any one culture. They
            resonate everywhere. That's why we've brought the project to
            Harrisonburg and Rockingham County, Virginia, where fathers and
            father-figures are being recognized through essay celebrations and
            community events like the{' '}
            <a href="https://www.downtownharrisonburg.org/best-weekend-ever" target="_blank" rel="noopener noreferrer" className="text-[#c06a2b] hover:underline font-medium" data-id="element-203" data-mp="1jpi9abt258zo">
              Best Weekend Ever
            </a>
            . Honoring fathers matters across cultures and communities. It
            strengthens the bonds between children and the adults who care for
            them, and it reminds us all of the importance of showing up.
          </p>
          <div className="flex flex-col items-center gap-3" data-id="element-204" data-mp="304jk9r8x5l4n">
            <div className="relative" data-id="element-205" data-mp="2vap06mpej451">
              <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-206" data-mp="2v9vs9iepi8lb"></div>
              <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-207" data-mp="32p7qpdasgm1k">
                <img src="https://cdn.magicpatterns.com/uploads/4o3KhNiRrq9YxLmuLcSFEr/BWE_FULLSET250-118.jpg.webp" alt="Families enjoying The Best Weekend Ever in Downtown Harrisonburg" className="w-full h-full object-cover" data-id="element-208" data-mp="3ckj863dl07d0" />
              </div>
            </div>
            <p className="text-sm text-[#5a3a28]/70 italic text-center mt-2" data-id="element-209" data-mp="3qjivn7pcyg7l">
              The Best Weekend Ever in Downtown Harrisonburg.
            </p>
          </div>
        </section>

        {/* Closing */}
        <section className="border-t border-[#ecdfd2] pt-12 mt-12" data-id="element-210" data-mp="44pnrdg4qbqo">
          <p className="text-lg text-[#5a3a28]/90 leading-relaxed" data-id="element-211" data-mp="87m5l1xui3tk">
            The Good Father Project continues to grow through the care of our
            community. Each essay written, each father honored, each partner
            that joins adds to something meaningful. We're grateful to everyone
            who has been part of this journey, and we look forward to what comes
            next.
          </p>
          <div className="mt-6" data-id="element-212" data-mp="18dqvzpj6314q">
            <Link to="/#partner" className="text-[#c06a2b] hover:text-[#3b2316] transition-colors text-sm font-medium" data-id="element-213" data-mp="18cpi7daro0jb">
              Partner With Us →
            </Link>
          </div>
        </section>
      </div>
    </main>;
}